module.exports = __webpack_public_path__ + "img/microsoft-logo.f4db3c57.png";